import { useAppSelector } from '../../useReduxToolkit';
import { getScreenshareState } from '../../../features/screenshare/screenshare.selectors';
import { useEffect } from 'react';
import { type TransitionFunc } from '../screenshareState.types';
import {
  ScreenshareState,
  ScreenshareTransition,
} from '../../../features/screenshare/screenshare.types';
import { useCallParticipants } from '../../useCallParticipants';

export const useLoadingRemoteStream = (
  onTransition: TransitionFunc,
): (() => Promise<void>) => {
  const screenshareState = useAppSelector(getScreenshareState);
  const { screenSharingParticipant } = useCallParticipants();

  useEffect(() => {
    if (
      screenshareState === ScreenshareState.LoadingRemoteStream &&
      screenSharingParticipant
    ) {
      void onTransition(ScreenshareTransition.LOADING_STREAM_DONE);
    }
  }, [screenshareState, screenSharingParticipant]);

  return async (): Promise<void> => {
    // nothing to do here, we just need the useEffect to run
    return undefined;
  };
};
